import { render, staticRenderFns } from "./StackedLoader.vue?vue&type=template&id=1948bacd&scoped=true&"
import script from "./StackedLoader.vue?vue&type=script&lang=js&"
export * from "./StackedLoader.vue?vue&type=script&lang=js&"
import style0 from "./StackedLoader.vue?vue&type=style&index=0&id=1948bacd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948bacd",
  null
  
)

export default component.exports